import { render, staticRenderFns } from "./DeltaBadge.vue?vue&type=template&id=2376fa5e&scoped=true&"
import script from "./DeltaBadge.vue?vue&type=script&lang=js&"
export * from "./DeltaBadge.vue?vue&type=script&lang=js&"
import style0 from "./DeltaBadge.vue?vue&type=style&index=0&id=2376fa5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2376fa5e",
  null
  
)

export default component.exports